import React from "react";
import "./style.scss";
import UsersList from "../../../components/Users/UsersList";
const UsersListPage = () => {
  return (
    <div className="users_list_page_wrapper">
      <UsersList />
    </div>
  );
};

export default UsersListPage;
